export default "__VITE_ASSET__Cpjv4S2G__"